
  import {Component, Vue, Watch} from 'vue-property-decorator';
import { Getter } from 'vuex-class';
  import {mediaLength} from "@/Services/helpers/VuexGetters";

@Component
export default class LengthChecker extends Vue {

  @Getter('transcriptionLength') transcriptionLength: number;
  @Getter('mediaLength') mediaLength: number;

   /** stebim ir palyginam įkeltų failų trukmes */
    @Watch('$store.getters.mediaLength')
    onMediaLengthChange(val, oldval) {
      if (!oldval && val) {
       this.checkImportedFilesDiff();
      }
    }
  /** stebim ir palyginam įkeltų failų trukmes */
  @Watch('$store.getters.transcriptionLength')
  onTranscriptionLengthChange(val, oldval) {
    if (!oldval && val) {
      this.checkImportedFilesDiff();
    }
  }

    /** palyginama importuotų failų trukmė */
    checkImportedFilesDiff () {
      if (!this.mediaLength || !this.transcriptionLength) {
        return;
      }
      const timeDiff = Math.abs(this.mediaLength - this.transcriptionLength);
      if (Math.abs(this.mediaLength - this.transcriptionLength) > 2) {
        this.$notify({
          text: this.$t("length_checker.different_length_message", {time_diff: Math.round(timeDiff)}).toString(),
          type: 'error',
        })
      }
    }
}
